import { getQueryParam } from '@vfde-sails/utils';
import {
    SAILS_BNT_STORAGE,
    SAILS_PARAM_ATOMIC_ID,
} from '@vfde-sails/constants';
import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { SailsTariffOverviewStorage } from 'Container/App/interface';

/**
 * Get Atomic ID
 */
export const getAtomicId = (): string | null => getAtomicIdFromUrl() ?? getAtomicFromStorage();

const getAtomicIdFromUrl = (): string | null => getQueryParam(SAILS_PARAM_ATOMIC_ID);

const getAtomicFromStorage = (): string | null => {
    const storage = getSessionStorageItemJson<SailsTariffOverviewStorage | null>(SAILS_BNT_STORAGE);
    const atomicId = storage?.[SAILS_PARAM_ATOMIC_ID];

    if (!atomicId) {
        return null;
    }

    return `${atomicId}`;
};
